import React from "react";

import TestDataSvg from "../../assets/images/icons/test-data.svg";

export const TestDataIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={TestDataSvg}
        alt={alt || "Test Data"}
    />
);
